import React from 'react';

/**
 * Fixed cover for the iOS status bar inset. Prevents scrolled content
 * from showing through the safe area when a fixed header hides in PWA mode.
 */
export function SafeAreaCover() {
  return (
    <div
      aria-hidden
      className="fixed top-0 left-0 right-0 z-40 bg-blue-50 dark:bg-gray-900 pointer-events-none"
      style={{ height: 'env(safe-area-inset-top)' }}
    />
  );
}
